import * as React from 'react';
import { useEffect, useState } from "react";

import { alpha } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import AppNavbar from '../components/AppNavbar';
import Header from '../components/Header';
import { CircularProgress, Typography  } from '@mui/material';
import MainGrid from '../components/MainGrid';
import SideMenu from '../components/SideMenu';
import AppTheme from '../shared-theme/AppTheme';
import NewTDPForm from '../components/NewTDPForm';

import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from './theme/customizations';

const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...treeViewCustomizations,
};
export default function CreateTDP(props) {

  return (
    <AppTheme {...props} themeComponents={xThemeComponents}>
      <CssBaseline enableColorScheme />
      <Box sx={{ display: 'flex' }}>
        <SideMenu />
        <AppNavbar />
        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
          <Header breadcrumbItems={[
            {label: 'AMX xConsole', href: '/'},
            {label: 'xTDP', href: '/x-tdp'},
            {label: 'New TDP'}
          ]}/>
          <NewTDPForm />
        </Box>
      </Box>
    </AppTheme>
  );
}